const mapInstructionAreasToOptions = instructionAreas =>
    instructionAreas.map(instructionArea => ({
        value: instructionArea.id,
        label: instructionArea.name,
    }));

export default mapInstructionAreasToOptions;
